/* Burner Pieces — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var ROOT = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

  /* ------------------------------------------------------------ toast -- */
  var toastTimer;
  function toast(message, linkHref, linkLabel) {
    var el = document.getElementById('BPToast');
    if (!el) return;
    el.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkLabel || 'View';
      el.appendChild(a);
    }
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4200);
  }

  function setOpen(el, open) {
    if (el) el.setAttribute('data-open', open ? 'true' : 'false');
  }

  function lockScroll(locked) {
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  /* ------------------------------------------------------- money utils -- */
  function formatMoney(cents, format) {
    var f = format || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f
      .replace('{{amount}}', whole + '.' + parts[1])
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', whole + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', whole);
  }

  /* --------------------------------------------------------- cart api -- */
  function updateCartCount() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () { /* count stays as-is */ });
  }

  function addToCart(payload, button) {
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding'; }

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(res.data.description || res.data.message || 'Could not add that to the bag.');
        }
        return updateCartCount().then(function () {
          toast('Added to bag', ROOT + 'cart', 'View bag');
          if (button) { button.disabled = false; button.textContent = original; }
          return res.data;
        });
      })
      .catch(function (err) {
        toast(err.message || 'Could not add that to the bag.');
        if (button) { button.disabled = false; button.textContent = original; }
      });
  }

  /* --------------------------------------------------- mobile drawer --- */
  function initDrawer() {
    var drawer = $('[data-nav-drawer]');
    if (!drawer) return;
    var openBtns = $$('[data-nav-open]');
    var closeBtns = $$('[data-nav-close]');

    function open() {
      setOpen(drawer, true);
      lockScroll(true);
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      setOpen(drawer, false);
      lockScroll(false);
      if (openBtns[0]) openBtns[0].focus();
    }

    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') close();
    });
  }

  /* ---------------------------------------------------------- facets --- */
  function initFacets() {
    var forms = $$('[data-facet-form]');

    function submitForm(form) {
      var data = new FormData(form);
      var params = [];
      data.forEach(function (value, key) {
        if (value === null || String(value).trim() === '') return;
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      var base = form.getAttribute('action') || window.location.pathname;
      window.location.href = params.length ? base + '?' + params.join('&') : base;
    }

    forms.forEach(function (form) {
      var debounce;
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="number"]')) return;
        submitForm(form);
      });
      form.addEventListener('input', function (e) {
        if (!e.target.matches('input[type="number"]')) return;
        clearTimeout(debounce);
        debounce = setTimeout(function () { submitForm(form); }, 700);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitForm(form);
      });
    });

    /* Show all / show fewer on long option lists */
    $$('[data-facet-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.bp-facets__panel');
        var list = panel ? $('[data-facet-list]', panel) : null;
        if (!list) return;
        var open = list.classList.toggle('is-open');
        list.classList.toggle('is-clamped', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show fewer' : 'Show all ' + list.children.length;
      });
    });

    /* Mobile filter sheet */
    var sheet = $('[data-facet-sheet]');
    var scrim = $('[data-facet-scrim]');
    if (!sheet) return;

    function openSheet() { setOpen(sheet, true); setOpen(scrim, true); lockScroll(true); }
    function closeSheet() { setOpen(sheet, false); setOpen(scrim, false); lockScroll(false); }

    $$('[data-facet-open]').forEach(function (b) { b.addEventListener('click', openSheet); });
    $$('[data-facet-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    if (scrim) scrim.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.getAttribute('data-open') === 'true') closeSheet();
    });
  }

  /* ---------------------------------------------------- contact form --- */
  function initContactForm() {
    var root = $('[data-contact-form]');
    if (!root) return;

    var groups = $$('[data-topic-group]', root);
    var radios = $$('[data-topic-input]', root);

    function apply(topic) {
      groups.forEach(function (group) {
        var match = group.getAttribute('data-topic-group') === topic;
        group.hidden = !match;
        $$('input, select, textarea', group).forEach(function (field) {
          field.disabled = !match;
          if (field.getAttribute('data-required') === 'true') {
            if (match) { field.setAttribute('required', 'required'); }
            else { field.removeAttribute('required'); }
          }
        });
      });
      syncConditionals(root);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        apply(radio.value);
        var group = root.querySelector('[data-topic-group="' + radio.value + '"]');
        if (group) {
          var first = group.querySelector('input:not([type="hidden"]), select, textarea');
          if (first) first.focus({ preventScroll: true });
        }
      });
    });

    var checked = radios.filter(function (r) { return r.checked; })[0];
    apply(checked ? checked.value : (radios[0] ? radios[0].value : ''));
    if (!checked && radios[0]) radios[0].checked = true;

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-reveal-trigger]')) syncConditionals(root);
    });
  }

  function syncConditionals(root) {
    $$('[data-reveal-target]', root).forEach(function (target) {
      var name = target.getAttribute('data-reveal-target');
      var wanted = (target.getAttribute('data-reveal-when') || '').split('|');
      var control = root.querySelector('[data-reveal-trigger][name="' + name + '"]');
      if (!control || control.disabled) { target.hidden = true; return; }
      var show = wanted.indexOf(control.value) !== -1;
      target.hidden = !show;
      $$('input, select, textarea', target).forEach(function (field) {
        field.disabled = !show;
      });
    });
  }

  /* -------------------------------------------------- variant picker --- */
  /* Works on any root, so the PDP and the quick view share one code path. */
  function initProductForm(root) {
    if (!root || root.getAttribute('data-bound') === 'true') return;
    root.setAttribute('data-bound', 'true');

    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = $('[data-variant-id]', root);
    var priceEl = $('[data-variant-price]', root);
    var submitBtn = $('[data-add-to-cart]', root);
    var skuEl = $('[data-variant-sku]', root);
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';

    function selectedOptions() {
      return $$('[data-option-index]', root)
        .filter(function (input) { return input.checked; })
        .sort(function (a, b) {
          return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index'));
        })
        .map(function (input) { return input.value; });
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.filter(function (v) {
        return v.options.length === chosen.length && v.options.every(function (opt, i) { return opt === chosen[i]; });
      })[0];

      $$('[data-option-label]', root).forEach(function (label) {
        var index = Number(label.getAttribute('data-option-label'));
        var input = $$('[data-option-index="' + index + '"]', root).filter(function (i) { return i.checked; })[0];
        if (input) label.textContent = input.value;
      });

      if (!match) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<span>' + formatMoney(match.price, moneyFormat) + '</span><span class="bp-price__was">' + formatMoney(match.compare_at_price, moneyFormat) + '</span>'
          : '<span>' + formatMoney(match.price, moneyFormat) + '</span>';
      }
      if (skuEl) skuEl.textContent = match.sku || '';
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }

      /* Only rewrite the address bar on the real product page. */
      if (history.replaceState && root.closest('.bp-product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) update();
    });

    /* AJAX add so the page never reloads out from under you. */
    var form = root.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qtyInput = $('input[name="quantity"]', form);
        addToCart({
          items: [{
            id: Number(idInput ? idInput.value : 0),
            quantity: Number(qtyInput ? qtyInput.value : 1) || 1
          }]
        }, submitBtn).then(function () {
          closeModal();
        });
      });
    }

    /* Quick view thumbnails */
    $$('[data-qv-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = $('[data-qv-main] img', root);
        if (main) main.src = thumb.getAttribute('data-qv-thumb');
        $$('[data-qv-thumb]', root).forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    update();
  }


  /* -------------------------------------------------- photo uploader ---- */
  /* Shopify's contact form cannot take files. Line item properties can, and
     they store on Shopify's own CDN. So we push the photos through a hidden
     zero-price product, pull the resulting URLs, drop the line straight back
     out of the cart, and post the URLs with the contact form. */
  function initUploader() {
    var root = $('[data-uploader]');
    if (!root) return;

    var variantId = Number(root.getAttribute('data-variant'));
    var maxFiles = Number(root.getAttribute('data-max') || 5);
    var input = $('[data-upload-input]', root);
    var zone = $('[data-upload-zone]', root);
    var list = $('[data-upload-list]', root);
    var status = $('[data-upload-status]', root);
    var fields = $('[data-upload-fields]', root);
    if (!variantId || !input) return;

    var uploaded = [];

    function say(msg, busy) {
      if (!status) return;
      status.textContent = msg || '';
      status.hidden = !msg;
      status.classList.toggle('is-busy', !!busy);
    }

    function syncFields() {
      fields.innerHTML = '';
      uploaded.forEach(function (item, i) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'contact[Return - Photo ' + (i + 1) + ']';
        hidden.value = item.url;
        fields.appendChild(hidden);
      });
      root.classList.toggle('has-files', uploaded.length > 0);
    }

    function render() {
      list.innerHTML = '';
      uploaded.forEach(function (item, i) {
        var li = document.createElement('li');
        li.className = 'bp-upload__item';

        var img = document.createElement('img');
        img.src = item.preview || item.url;
        img.alt = '';
        li.appendChild(img);

        var name = document.createElement('span');
        name.className = 'bp-upload__name';
        name.textContent = item.name;
        li.appendChild(name);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'bp-upload__remove';
        remove.setAttribute('aria-label', 'Remove ' + item.name);
        remove.innerHTML = '&times;';
        remove.addEventListener('click', function () {
          uploaded.splice(i, 1);
          render();
          syncFields();
          say(uploaded.length ? uploaded.length + ' photo(s) attached' : '');
        });
        li.appendChild(remove);

        list.appendChild(li);
      });
      syncFields();
    }

    /* Shrink big phone photos before upload so this works on slow connections. */
    function downscale(file) {
      return new Promise(function (resolve) {
        if (!/^image\//.test(file.type) || typeof createImageBitmap !== 'function') {
          resolve(file);
          return;
        }
        createImageBitmap(file).then(function (bitmap) {
          var max = 1600;
          if (bitmap.width <= max && bitmap.height <= max && file.size < 1500000) {
            resolve(file);
            return;
          }
          var scale = Math.min(max / bitmap.width, max / bitmap.height, 1);
          var canvas = document.createElement('canvas');
          canvas.width = Math.round(bitmap.width * scale);
          canvas.height = Math.round(bitmap.height * scale);
          canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(function (blob) {
            resolve(blob ? new File([blob], file.name.replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file);
          }, 'image/jpeg', 0.85);
        }).catch(function () { resolve(file); });
      });
    }

    function upload(files) {
      var room = maxFiles - uploaded.length;
      if (room <= 0) { say('That is the maximum of ' + maxFiles + ' photos.'); return; }

      var picked = files.slice(0, room).filter(function (f) { return /^image\//.test(f.type); });
      if (!picked.length) { say('Please choose image files.'); return; }

      say('Uploading ' + picked.length + ' photo(s)', true);

      Promise.all(picked.map(downscale)).then(function (prepared) {
        var body = new FormData();
        body.append('id', variantId);
        body.append('quantity', 1);
        prepared.forEach(function (file, i) {
          body.append('properties[Return photo ' + (uploaded.length + i + 1) + ']', file, file.name);
        });

        return fetch(ROOT + 'cart/add.js', { method: 'POST', body: body })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || 'Upload failed');
            var item = res.data.items ? res.data.items[0] : res.data;
            var props = item.properties || {};

            Object.keys(props).forEach(function (key, i) {
              var url = props[key];
              if (typeof url !== 'string' || url.indexOf('http') !== 0) return;
              uploaded.push({
                url: url,
                name: prepared[i] ? prepared[i].name : 'photo',
                preview: prepared[i] ? URL.createObjectURL(prepared[i]) : url
              });
            });

            /* Take the helper line straight back out so no one checks it out. */
            return fetch(ROOT + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            }).catch(function () {});
          })
          .then(function () {
            render();
            updateCartCount();
            say(uploaded.length + ' photo(s) attached');
            input.value = '';
          });
      }).catch(function () {
        say('Those photos would not upload. Email them to us instead and we will attach them.');
        input.value = '';
      });
    }

    input.addEventListener('change', function () {
      upload(Array.prototype.slice.call(input.files));
    });

    ['dragenter', 'dragover'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        zone.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        zone.classList.remove('is-over');
      });
    });
    zone.addEventListener('drop', function (e) {
      if (!e.dataTransfer || !e.dataTransfer.files) return;
      upload(Array.prototype.slice.call(e.dataTransfer.files));
    });
  }

  /* ----------------------------------------------------- quick view ---- */
  var lastTrigger = null;

  function modalEl() { return $('[data-modal]'); }

  function openModal() {
    var modal = modalEl();
    if (!modal) return;
    setOpen(modal, true);
    lockScroll(true);
  }

  function closeModal() {
    var modal = modalEl();
    if (!modal || modal.getAttribute('data-open') !== 'true') return;
    setOpen(modal, false);
    lockScroll(false);
    var body = $('[data-modal-body]', modal);
    if (body) body.innerHTML = '';
    if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
  }

  function showModalSpinner() {
    var body = $('[data-modal-body]', modalEl());
    if (body) body.innerHTML = '<div class="bp-modal__loading"><span class="bp-spinner" role="status" aria-label="Loading"></span></div>';
  }

  function initQuickActions() {
    document.addEventListener('click', function (e) {
      /* Single-variant products skip the modal entirely. */
      var addBtn = e.target.closest('[data-quick-add]');
      if (addBtn) {
        e.preventDefault();
        addToCart({ items: [{ id: Number(addBtn.getAttribute('data-quick-add')), quantity: 1 }] }, addBtn);
        return;
      }

      var viewBtn = e.target.closest('[data-quick-view]');
      if (!viewBtn) return;
      e.preventDefault();

      lastTrigger = viewBtn;
      var url = viewBtn.getAttribute('data-quick-view');
      openModal();
      showModalSpinner();

      fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=quick-view')
        .then(function (r) {
          if (!r.ok) throw new Error('Could not load that piece.');
          return r.text();
        })
        .then(function (html) {
          var body = $('[data-modal-body]', modalEl());
          if (!body) return;
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var section = wrapper.querySelector('.bp-qv') || wrapper;
          body.innerHTML = '';
          body.appendChild(section);
          initProductForm($('[data-product-form]', body));
          var focusable = body.querySelector('button, [href], input, select');
          if (focusable) focusable.focus();
        })
        .catch(function () {
          closeModal();
          window.location.href = url;
        });
    });

    var modal = modalEl();
    if (!modal) return;

    $$('[data-modal-close]', modal).forEach(function (b) { b.addEventListener('click', closeModal); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
      if (e.key !== 'Tab' || modal.getAttribute('data-open') !== 'true') return;
      var items = $$('button, [href], input:not([disabled]), select, textarea', modal)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ----------------------------------------------------- qty steppers -- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var wrap = btn.closest('.bp-qty');
      var input = $('input', wrap);
      if (!input) return;
      var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
      var min = Number(input.getAttribute('min') || 1);
      input.value = Math.max(min, (Number(input.value) || min) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initCart() {
    var form = $('[data-cart-form]');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) form.submit();
    });
  }

  function initNewsletter() {
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      toast('You are on the list');
    }
  }

  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var items = $$('[data-reveal]').filter(function (el) { return !el.getAttribute('data-revealed'); });
    if (!items.length) return;

    items.forEach(function (el) {
      el.setAttribute('data-revealed', 'pending');
      el.style.opacity = '0';
      el.style.transform = 'translateY(14px)';
      el.style.transition = 'opacity 620ms cubic-bezier(.22,.61,.36,1), transform 620ms cubic-bezier(.22,.61,.36,1)';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'none';
        entry.target.setAttribute('data-revealed', 'done');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    initDrawer();
    initFacets();
    initContactForm();
    initUploader();
    $$('[data-product-form]').forEach(initProductForm);
    initQuickActions();
    initQty();
    initCart();
    initNewsletter();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
